import { connect } from 'react-redux';
import Report from '../../components/report/Report';

const mapStateToProps = ({report}) => ({
});

const mapDispatchToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(Report);
